// extracted by mini-css-extract-plugin
module.exports = {"title":"MakeAndModel_title__MPkiK"};